import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import walletApi from '@/services/apis/wallet'
import { GetWalletListDTO, WalletPaginationModel, WalletType } from '@/services/apis/wallet/models'
import { CoinBasis } from '@/services/apis/coin/models'
import coinApi from '@/services/apis/coin'

export interface WalletSliceState {
  isGetWalletsLoading: boolean
  isGetWalletsHideLoading: boolean
  walletsPagination: WalletPaginationModel

  walletsQuery: {
    accountType: WalletType
    name: string
    pageNumber: number
  }

  walletsRefresh: number

  walletsSearchValue: string
  basicCoinList: CoinBasis[]
}

const initialState: WalletSliceState = {
  isGetWalletsLoading: false,
  isGetWalletsHideLoading: false,
  walletsRefresh: Date.now(), // 用于强制刷新

  walletsPagination: {
    totalElements: 0,
    totalPages: 0,
    pageSize: 0,
    pageNumber: 0,
    content: [],
  },
  walletsQuery: {
    accountType: WalletType.all,
    name: '',
    pageNumber: 1,
  },

  walletsSearchValue: '',
  basicCoinList: [],
}

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    resetShowWalletPagination(state) {
      state.walletsPagination = initialState.walletsPagination
    },

    resetWalletsQuery(state) {
      state.walletsQuery = initialState.walletsQuery
      state.walletsSearchValue = ''
      state.walletsRefresh = Date.now()
    },
    resetShowWallets(state) {
      state.walletsRefresh = Date.now()
    },

    setWalletsQuery(state, action) {
      Object.assign(state.walletsQuery, action.payload)
    },

    setWalletsSearchValue(state, action) {
      state.walletsSearchValue = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getWalletList.pending, state => {
        state.isGetWalletsLoading = true
      })
      .addCase(getWalletList.fulfilled, (state, action) => {
        if (action.payload) {
          state.walletsPagination = action.payload
        }
        state.isGetWalletsLoading = false
      })
      .addCase(getWalletList.rejected, state => {
        state.isGetWalletsLoading = false
      })
      .addCase(getBasicCoinList.fulfilled, (state, action) => {
        state.basicCoinList = action.payload || []
      })
  },
})

export const getWalletList = createAsyncThunk<WalletPaginationModel, GetWalletListDTO>(
  'wallet/getWalletList',
  async dto => {
    const res = await walletApi.getWalletList(dto)
    return res.data
  }
)

export const getBasicCoinList = createAsyncThunk<CoinBasis[] | undefined>(
  '/wallet/getBasicCoinList',
  async () => {
    const res = await coinApi.getBasicCoinList()
    if (res.success) {
      return res.data
    }
  }
)

export const {
  resetShowWalletPagination,

  resetWalletsQuery,
  resetShowWallets,

  setWalletsQuery,
  setWalletsSearchValue,
} = walletSlice.actions

export default walletSlice.reducer
